import { useState, useEffect } from 'react';

/**
 * Fetches the live app version from /api/health.
 * Falls back to build-time __APP_VERSION__ if API is unreachable.
 * This ensures version consistency across DEV and PROD environments.
 */
export function useAppVersion(): string {
  const [version, setVersion] = useState<string>(__APP_VERSION__);

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const API_BASE = window.location.hostname === 'localhost' ? 'http://localhost:3000' : 'https://app.fahryo.de';
        const resp = await fetch(`${API_BASE}/api/health`);
        if (resp.ok) {
          const data = await resp.json();
          if (data.version) setVersion(data.version);
        }
      } catch {
        // Keep build-time version as fallback
      }
    };
    fetchVersion();
  }, []);

  return version;
}
